/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.conversations.email.rpc.ConnectedAccountRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const RoutingRuleDefinitionDiscriminantKey = '@type';
export const AiChatbotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.AiChatbotRouting';
export const AiChatbotRoutingDiscriminant = 'AI_CHATBOT';
export const AiChatbotRoutingDiscriminantKey = '@type';
export const BotRoutingTypename = 'com.hubspot.cv.assignments.core.routing.BotRouting';
export const BotRoutingDiscriminant = 'BOT';
export const BotRoutingDiscriminantKey = '@type';
export const CustomerAgentComplexRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentComplexRouting';
export const CustomerAgentComplexRoutingDiscriminant = 'CUSTOMER_AGENT_COMPLEX';
export const CustomerAgentComplexRoutingDiscriminantKey = '@type';
export const CustomerAgentRoutingTypename = 'com.hubspot.cv.assignments.core.routing.CustomerAgentRouting';
export const CustomerAgentRoutingDiscriminant = 'CUSTOMER_AGENT';
export const CustomerAgentRoutingDiscriminantKey = '@type';
export const InboxUsersRoutingTypename = 'com.hubspot.cv.assignments.core.routing.InboxUsersRouting';
export const InboxUsersRoutingDiscriminant = 'INBOX_USERS';
export const InboxUsersRoutingDiscriminantKey = '@type';
export const OwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.OwnerRouting';
export const OwnerRoutingDiscriminant = 'OWNER';
export const OwnerRoutingDiscriminantKey = '@type';
export const QuoteOwnerRoutingTypename = 'com.hubspot.cv.assignments.core.routing.QuoteOwnerRouting';
export const QuoteOwnerRoutingDiscriminant = 'QUOTE_OWNER';
export const QuoteOwnerRoutingDiscriminantKey = '@type';
export const SkillBasedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillBasedRouting';
export const SkillBasedRoutingDiscriminant = 'SKILL_BASED_ROUTING';
export const SkillBasedRoutingDiscriminantKey = '@type';
export const SkillRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SkillRouting';
export const SkillRoutingDiscriminant = 'SKILL';
export const SkillRoutingDiscriminantKey = '@type';
export const SpecifiedHoursRoutingTypename = 'com.hubspot.cv.assignments.core.routing.SpecifiedHoursRouting';
export const SpecifiedHoursRoutingDiscriminant = 'SPECIFIED_HOURS';
export const SpecifiedHoursRoutingDiscriminantKey = '@type';
export const TeamsOnlyRoutingTypename = 'com.hubspot.cv.assignments.core.routing.TeamsOnlyRouting';
export const TeamsOnlyRoutingDiscriminant = 'TEAMS_ONLY';
export const TeamsOnlyRoutingDiscriminantKey = '@type';
export const UnassignedRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UnassignedRouting';
export const UnassignedRoutingDiscriminant = 'UNASSIGNED';
export const UnassignedRoutingDiscriminantKey = '@type';
export const UsersAndTeamsRoutingTypename = 'com.hubspot.cv.assignments.core.routing.UsersAndTeamsRouting';
export const UsersAndTeamsRoutingDiscriminant = 'USERS_AND_TEAMS';
export const UsersAndTeamsRoutingDiscriminantKey = '@type';
export const WaitlistRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WaitlistRouting';
export const WaitlistRoutingDiscriminant = 'WAITLIST';
export const WaitlistRoutingDiscriminantKey = '@type';
export const WorkflowRoutingTypename = 'com.hubspot.cv.assignments.core.routing.WorkflowRouting';
export const WorkflowRoutingDiscriminant = 'WORKFLOW_ROUTING';
export const WorkflowRoutingDiscriminantKey = '@type';
export const checkEmailConnectedAccountExistsRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'checkEmailConnectedAccountExists',
  auth: 'app',
  fingerprint: 'Vak8v5sxIv_SlF_juZXNUZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteConnectedAccountRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'deleteConnectedAccount',
  auth: 'app',
  fingerprint: '2qCS7LBrW09Qm1jUEF-E1pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteConnectedAccountByChannelInstanceRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'deleteConnectedAccountByChannelInstance',
  auth: 'app',
  fingerprint: '2_QAvWQDDdW7VzqrLJjHNpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectedAccountByIdRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getConnectedAccountById',
  auth: 'app',
  fingerprint: 'LYJ8sLv4WccRkhOAEOORG5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectedAccountAccessResultRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getConnectedAccountAccessResult',
  auth: 'app',
  fingerprint: 'iX_Xl5EAtGvkRrME7oSx3JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectedAccountsForUserRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getConnectedAccountsForUser',
  auth: 'app',
  fingerprint: 'IhbN1Nac8TfTs6xkOzrKwZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectedAccountsByInboxIdForUserRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getConnectedAccountsByInboxIdForUser',
  auth: 'app',
  fingerprint: 'vSR3wH7FYD7ltWXenMi_0ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllConnectedAccountEmailsByInboxIdRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getAllConnectedAccountEmailsByInboxId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACML4CiN5-5CJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConnectedAccountsForSettingsRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getConnectedAccountsForSettings',
  auth: 'app',
  fingerprint: 'X8MJCHX53JSVBnNEeeD0IpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendTestVisitorMessageRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'sendTestVisitorMessage',
  auth: 'app',
  fingerprint: 'l1eaA2FAKsvzwGF05fugrDrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendTestVisitorMessageSyncRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'sendTestVisitorMessageSync',
  auth: 'app',
  fingerprint: 'l1eaA2FAKsuZNxrWayyibDrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createConnectedAccountRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'createConnectedAccount',
  auth: 'app',
  fingerprint: 'DHx0xPiyMlVKkD2m7CREBzrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateConnectedAccountRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'updateConnectedAccount',
  auth: 'app',
  fingerprint: 'RHgDPGOSpM9KkD2m7CREBzrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendDisconnectedEmailRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'sendDisconnectedEmail',
  auth: 'app',
  fingerprint: 'tR2EACtmoPyOUe2e_r4XmTrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonDeletedConnectedAccountByChannelInstanceRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getNonDeletedConnectedAccountByChannelInstance',
  auth: 'app',
  fingerprint: 'KkxB9gGhzu6I7vs6_pLC1pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefaultSenderForThreadRpc = {
  serviceName: 'com.hubspot.conversations.email.rpc.ConnectedAccountRpc',
  rpcName: 'getDefaultSenderForThread',
  auth: 'app',
  fingerprint: 'l0ps3OOTsxOF1k5D6KjbMzrDSNjzga7J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};